













import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { Id } from '../types/eid';
import EIdIcon from './EIdIcon.vue';

export default defineComponent({
  components: {
    EIdIcon,
  },
  props: {
    option: {
      type: Object as PropType<Id>,
      required: true,
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const select = () => {
      if (!props.disableClick) {
        emit('select', props.option);
      }
    };

    return {
      select,
    };
  },
});
